
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 320 320"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D52B1E","d":"M0 0h320v320H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M60 130h200v60H60z"}}),_c('path',{attrs:{"fill":"#fff","d":"M130 60h60v200h-60z"}})])
          )
        }
      }
    